import { RootDetails } from "@/pages/ladle-track/plant-overview/models/root-detail.dto";
import { ladlesRepository } from "@/repositories/roots/ladlesRepository";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LadlePlantOverviewDTO } from "../../models/ladle-plant-overview.dto";

interface PlantOverviewState extends LadlePlantOverviewDTO {
	error: string;
	isLoading?: boolean;
	ladleSelected: RootDetails | null;
	timerIsOn: boolean;
	orphanHeat?: {
		heatName: string;
		heatId: number;
	};
	tapTempThreshold: number | null;
	tapTempAlertActive: boolean;
}

const initialState: PlantOverviewState = {
	error: "",
	locations: {},
	eaFs: {},
	isLoading: false,
	ladleSelected: null,
	timerIsOn: true,
	tapTempThreshold: null,
	tapTempAlertActive: false,
};

export const getPlantOverviewGeneral = createAsyncThunk(
	"@plantoverview/getLadlePlantOverview",
	async () => {
		return await ladlesRepository.getLadlePlantOverview();
	},
);

export const getTapTempAlertConfig = createAsyncThunk(
	"@plantoverview/getTapTempAlertConfig",
	async () => {
		return await ladlesRepository.getTapTempAlertConfiguration();
	},
);

export const PlantOverviewReducer = createSlice({
	name: "@plantoverview/general",
	initialState,
	reducers: {
		setLadlePOError(state, action) {
			state.error = action.payload;
		},
		setOverview: (state, action) => {},
		setLadleSelected: (state, { payload }) => {
			state.ladleSelected = payload;
		},
		setIsTimerOn(state, { payload }) {
			state.timerIsOn = payload;
		},
		setOrphanHeatToAssignLadle(state, { payload }) {
			state.orphanHeat = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getPlantOverviewGeneral.fulfilled, (state, action) => {
				if (action.payload.error) {
					state.error = action.payload.message;
				} else {
					Object.assign(state, action.payload.data);
					state.isLoading = false;
				}
			})
			.addCase(getPlantOverviewGeneral.pending, (state, _) => {
				state.isLoading = true;
			})
			.addCase(getPlantOverviewGeneral.rejected, (state, action) => {
				state.error = "Error occured";
			})
			.addCase(getTapTempAlertConfig.fulfilled, (state, action) => {
				state.tapTempThreshold = action.payload?.threshold ?? null;
				state.tapTempAlertActive = action.payload?.isActive ?? false;
			});
	},
});

export const {
	setLadleSelected,
	setIsTimerOn: setIsTimerPoOn,
	setOrphanHeatToAssignLadle,
	setLadlePOError,
} = PlantOverviewReducer.actions;
